export const statusClasses = {
    open: 'bg-danger',
    disputed: 'bg-warning',
    reopened: 'bg-primary',
    closed: 'bg-success',
    archive: 'bg-danger',
    observation: 'bg-secondary',
};

export const priorityClasses = {
    high: 'bg-danger',
    medium: 'bg-warning',
    low: 'bg-primary',
    urgent: 'bg-danger',
};

export const priorityOptions = [
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
];

export const statusOptions = [
    { value: 'open', label: 'Open' },
    { value: 'closed', label: 'Closed' },
    { value: 'reopened', label: 'Reopened' },
    { value: 'disputed', label: 'Disputed' },
    { value: 'observation', label: 'Observation' },
    { value: 'archive', label: 'Archived' },
];

export const proposalStatusOptions = [
    { value: 'draft', label: 'Draft' },
    { value: 'sent', label: 'Sent' },
    { value: 'open', label: 'Open' },
    { value: 'revised', label: 'Revised' },
    { value: 'declined', label: 'Declined' },
    { value: 'accepted', label: 'Accepted' },
]

export const currencyOptions = [
    { value: 'usd', label: 'USD' },
    { value: 'eur', label: 'EUR' },
    { value: 'gbp', label: 'GBP' },
    { value: 'inr', label: 'INR' },
    { value: 'aed', label: 'AED' },
];

export const discountTypeOptions = [
    { value: 'no_discount', label: 'No Discount' },
    { value: 'before_tax', label: 'Before Tax' },
    { value: 'after_tax', label: 'After Tax' },
];


export const recurringOptions = [
    { value: 'no', label: 'No' },
    { value: '1', label: 'Every 1 month' },
    { value: '2', label: 'Every 2 months' },
    { value: '3', label: 'Every 3 months' },
    { value: '4', label: 'Every 4 months' },
    { value: '5', label: 'Every 5 months' },
    { value: '6', label: 'Every 6 months' },
    { value: '7', label: 'Every 7 months' },
    { value: '8', label: 'Every 8 months' },
    { value: '9', label: 'Every 9 months' },
    { value: '10', label: 'Every 10 months' },
    { value: '11', label: 'Every 11 months' },
    { value: '12', label: 'Every 12 months' },
    { value: 'custom', label: 'Custom' },
];
export const validityInMonths = {
    "monthly": 1,
    "3 monthly": 3,
    "6 monthly": 6,
    "yearly": 12,
};

export const industryOptions = [
    { value: 'agriculture', label: 'Agriculture' },
    { value: 'automotive', label: 'Automotive' },
    { value: 'banking', label: 'Banking' },
    { value: 'construction', label: 'Construction' },
    { value: 'consulting', label: 'Consulting' },
    { value: 'education', label: 'Education' },
    { value: 'energy', label: 'Energy' },
    { value: 'finance', label: 'Finance' },
    { value: 'government', label: 'Government' },
    { value: 'healthcare', label: 'Healthcare' },
    { value: 'hospitality', label: 'Hospitality' },
    { value: 'manufacturing', label: 'Manufacturing' },
    { value: 'media', label: 'Media' },
    { value: 'retail', label: 'Retail' },
    { value: 'research', label: 'Research' },
    { value: 'staffing-and-recruiting', label: 'Staffing and Recruiting' },
    { value: 'information-technology', label: 'Information Technology' },
    { value: 'transportation', label: 'Transportation' },
    { value: 'other', label: 'Other' },
];

export const empoyeeCountOptions = [
    { value: '1-10', label: '1-10' },
    { value: '11-50', label: '11-50' },
    { value: '51-200', label: '51-200' },
    { value: '201-500', label: '201-500' },
    { value: '501-1000', label: '501-1000' },
    { value: '1001+', label: '1001+' },
]

export const leadStatusOptions = [
    { value: 'call-done', label: 'Call Done' },
    { value: 'follow-up', label: 'Follow Up' },
    { value: 'in-progress', label: 'In Progress' },
    { value: 'invalid', label: 'Invalid' },
    { value: 'loss', label: 'Loss' },
    { value: 'mail-done', label: 'Mail Done' },
    { value: 'no-action', label: 'No Action' },
    { value: 'on-hold', label: 'On Hold' },
    { value: 'price-awaited', label: 'Price Awaited' },
    { value: 'quotation-shared', label: 'Quotation Shared' },
    { value: 'won', label: 'Won' }
];


export const leadSourceOptions = [
    { value: 'broadline', label: 'Broadline' },
    { value: 'cold-call', label: 'Cold Call' },
    { value: 'company', label: 'Company' },
    { value: 'field-sales-calling', label: 'Field Sales Calling' },
    { value: 'indiamart', label: 'Indiamart' },
    { value: 'mail', label: 'Mail' },
    { value: 'mailer', label: 'Mailer' },
    { value: 'microsoft', label: 'Microsoft' },
    { value: 'old-client', label: 'Old Client' },
    { value: 'other', label: 'Other' },
    { value: 'pre-sale', label: 'Pre Sale' },
    { value: 'referral', label: 'Referral' },
    { value: 'social-media', label: 'Social Media' },
    { value: 'field-visit', label: 'Field Visit' },
    { value: 'warm-call', label: 'Warm Call' },
    { value: 'website', label: 'Website' }
];

export const profilingStatusOptions = [
    { value: 'pending', label: 'Pending' },
    { value: 'verified', label: 'Verified' },
    { value: 'unverified', label: 'Unverified' },
    { value: 'convert', label: 'Convert to Lead' },
];

export const billingCycleOptions = [
    { value: 'monthly', label: 'Monthly' },
    { value: '3-monthly', label: '3 Monthly' },
    { value: '6-monthly', label: '6 Monthly' },
    { value: 'yearly', label: 'Yearly' },
    { value: 'custom', label: 'Custom' },
];

export const taskStatusOptions = [
    { value: 'not_started', label: 'Not Started' },
    { value: 'in_progress', label: 'In Progress' },
    { value: 'completed', label: 'Completed' },
    { value: 'on_hold', label: 'On Hold' },
    { value: 'awaiting_feedback', label: 'Awaiting Feedback' },
    { value: 'testing', label: 'Testing' },
  ];

  export const productTicketTypeOptions = [
    { value: 'demo', label: 'Demo' },
    { value: 'without_product', label: 'Without Product' },
    { value: 'anonymous', label: 'Anonymous' },
    { value: 'other', label: 'Other' },
  ];

  export const customerStatusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'blacklisted', label: 'Blacklisted' }
  ];
  
